import React, { Component } from 'react'
import { connect } from 'react-redux'
import { GoogleMap, MarkerClusterer, Marker } from '@react-google-maps/api'

import {
  changeMapZoom,
  changeMapCenter,
  callImages,
  resetImages
} from '../actions'

import { config } from '../config'

import { holeHelper } from '../helpers'
import { URIS } from '../Uris'

const initialState = {
  heatMapData: null,
  latitude: 45.64843,
  longitude: 9.37813,
  zoom: 9,
  loadCluster: true,
  plusCodes: false
}

class Map extends Component {
  constructor() {
    super()
    this.state = initialState
    this.zoomChange = this.zoomChange.bind(this)
  }

  location(l) {
    return { lat: l.latitude, lng: l.longitude }
  }

  zoomChange() {
    if (this.refs.Gmap) {
      const zoom = this.props.dashboard.zoom
      const futureZoom = this.refs.Gmap.state.map.zoom
      if (zoom !== futureZoom) {
        this.props.changeMapZoom(futureZoom)
      }
    }
  }

  loadImages() {
    const d = this.props.dashboard
    if (d.zoom >= 11 && d.images === null) {
      console.log('call images')
      this.props.callImages({
        latitude: this.props.dashboard.latitude,
        longitude: this.props.dashboard.longitude
      })
    }
  }

  centerChange() {
    if (this.refs.Gmap) {
      const { latitude, longitude } = this.props.dashboard.zoom
      const futureCenter = this.refs.Gmap.state.map.center
      const lat = futureCenter.lat()
      const lng = futureCenter.lng()
      if (latitude !== lat || longitude !== lng) {
        this.props.changeMapCenter({ lat, lng })
      }
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.dashboard.clusterSize !== this.props.dashboard.clusterSize) {
      this.setState({ loadCluster: false }, () => {
        this.setState({ loadCluster: true })
      })
    }
  }

  plusCodesHandler = () => {
    var roadmapOverlay = new window.google.maps.ImageMapType({
      getTileUrl: function (coord, zoom) {
        // Using WMS tile numbering.
        return [
          'https://grid.plus.codes/grid/wms/',
          zoom,
          '/',
          coord.x,
          '/',
          coord.y,
          '.png'
        ].join('')
      },
      tileSize: new window.google.maps.Size(256, 256)
    })
    this.refs.Gmap.state.map.overlayMapTypes.clear()
    if (!this.state.plusCodes) {
      this.refs.Gmap.state.map.overlayMapTypes.push(roadmapOverlay)
    }
    this.setState({ plusCodes: !this.state.plusCodes })
  }

  render() {
    const {
      list,
      latitude,
      longitude,
      zoom,
      clusterSize,
      images,
      showImageLayer,
      showHoleLayer
    } = this.props.dashboard
    const filteredImages = this.props.filteredImages
    return (
      <div className={'map ' + this.props.css}>
        <button className='lnk-codes' onClick={() => this.plusCodesHandler()}>
          <i className='fas fa-braille'></i>
        </button>
        <GoogleMap
          mapContainerStyle={{
            height: '100%',
            width: '100%'
          }}
          ref='Gmap'
          options={config.googleMapStyle}
          zoom={zoom}
          center={{ lat: latitude, lng: longitude }}
          onZoomChanged={() => this.zoomChange()}
          onDragEnd={() => this.centerChange()}
        >
          {list && this.state.loadCluster && showHoleLayer && (
            <MarkerClusterer
              options={{ imagePath: URIS.clusters + 'anomalies/' }}
              minimumClusterSize={clusterSize}
              onClick={(e) => this.props.clusterClick(e)}
            >
              {(clusterer) =>
                (list || []).map((location, i) => (
                  <Marker
                    key={i}
                    position={this.location(location)}
                    clusterer={clusterer}
                    onClick={(e) => this.props.markerClick(location.id)}
                    icon={holeHelper.holeMarker(location)}
                    zIndex={location.severity}
                  />
                ))
              }
            </MarkerClusterer>
          )}
          {images && this.state.loadCluster && showImageLayer && (
            <MarkerClusterer
              options={{ imagePath: URIS.clusters + 'photos/' }}
              minimumClusterSize={clusterSize}
              onClick={(e) => this.props.clusterClick(e)}
            >
              {(clusterer) =>
                (filteredImages || []).map((image, i) => (
                  <Marker
                    key={i}
                    position={this.location(image)}
                    clusterer={clusterer}
                    onClick={(e) => this.props.imageClick(image)}
                    icon={holeHelper.photoMarker(image)}
                    zIndex={1}
                  />
                ))
              }
            </MarkerClusterer>
          )}
        </GoogleMap>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return state
}

export default connect(mapStateToProps, {
  changeMapZoom,
  changeMapCenter,
  callImages,
  resetImages
})(Map)
